export enum CHART_PERIODS {
    DAILY = "daily",
    WEEKLY = "weekly",
    MONTHLY = "monthly",
    /** One day: each call shown by time (HH:mm) and overall score */
    TWENTY_FOUR_HOURS = "24_hours",
}

export type ChartPeriod = (typeof CHART_PERIODS)[keyof typeof CHART_PERIODS];

// Date range constants for chart periods
export const DAILY_PERIOD_DAYS = 20;
export const WEEKLY_PERIOD_WEEKS = 12;
export const MONTHLY_PERIOD_MONTHS = 12;

export enum QUALITY_WATCH_ENTITY_TYPES {
    AGENT = "agent",
    TEAM = "team",
    BRAND = "brand",
}

export enum CHART_LAYOUT_TYPES {
    COMBINED = "combined",
    SEPARATE = "separate",
}

export type ChartLayout = (typeof CHART_LAYOUT_TYPES)[keyof typeof CHART_LAYOUT_TYPES];

// Default chart line color
export const DEFAULT_CHART_LINE_COLOR = "#8884d8";

// Default stroke dasharray values for fallback when parsing fails
export const DEFAULT_STROKE_DASH_LENGTH = 5;
export const DEFAULT_STROKE_GAP_LENGTH = 10;

// Chart height constants
export const DEFAULT_CHART_HEIGHT = 600;
export const MIN_CHART_HEIGHT = 400;
export const MAX_CHART_HEIGHT = 800;

// Call purposes for Quality Watch filter (must match backend CALL_PURPOSES values)
export const CALL_PURPOSES = {
    APPOINTMENT: "Phone Appointment",
    FOLLOW_UP: "Follow Up",
    SETTING: "Setting",
    CUSTOMER_CARE: "Customer Care",
    REQUEST_IMAGES: "Request Images",
    SECOND_SESSION: "Second Session",
    CANCELLATION: "Cancellation",
    RECRUITING: "Recruiting",
    MANUAL: "Manual",
    OTHER: "Other",
} as const;

export type CallPurposeValue = (typeof CALL_PURPOSES)[keyof typeof CALL_PURPOSES];
